// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"e5f5b738","254":"e710f36b","259":"e70086f5","338":"2e26ede9","365":"715a5f60","522":"296d25d6","591":"5ebe7962","657":"4ce63aac","781":"464be47f","810":"24759f9a","928":"334c881f","958":"fd4213b5"}[chunkId] + ".chunk.css";
};